// import { _mock } from 'src/_mock';

// TO GET THE USER FROM THE AUTHCONTEXT, YOU CAN USE

// CHANGE:
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// const { user } = useMockedUser();

// TO:
import { useAuthContext } from 'src/auth/hooks';


// ----------------------------------------------------------------------

export function useMockedUser() {
  const { user } = useAuthContext();
  // const user = {
  //   id: '0000',
  //   displayName: 'Dany Almeida',
  //   email: 'dany_almeida@outlook.pt',
  //   role: 'admin',
  //   isPublic: true,
  // };

  return { user };
}
